import axios from 'axios';
import React, { useEffect, useState } from 'react'

// type PropsType = {
//     url: string
// }
export const useFetch = (url: string) => {
    const [data, setData] = useState<[] | any>();
    const [loading, setLoading] = useState(false);
    // const [successMsg,setSuccessMsg]=useState('');
    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {
        const fetch = async () => {
            try {
                setLoading(true)
                await axios.get(`${process.env.REACT_APP_API}/${url}`).then(res => {
                    setData(res.data);
                })
            } catch (error: any) {
                if (error.response.message) {
                    setErrMsg(error.response.message)
                }
            }
            setLoading(false)
        }
        fetch()

    }, [url])

    return { data, loading, errMsg }
}

